<ng-container *appLet="navProgressElements$ | async as navProgressElements">
  <section class="container">
    @if (navProgressElements !== null && navProgressElements !== undefined) {
      <app-information-message class="hide-only-on-print" [alertKey]="AlertKey.PensionPlan"></app-information-message>
      <app-expandable-data-alerts class="hide-only-on-print"></app-expandable-data-alerts>
    }
    <router-outlet></router-outlet>
  </section>

  @if (!(simulationParametersPartialWithdrawalByEngagementEnable$ | async)) {
    <app-nav-progress [buttons$]="navigation$" [progress]="progress$ | async" [class.hide]="hideNavigation$ | async">
      @if (navProgressElements?.includes(NavProgressElements.Parameters)) {
        <app-simulation-params-activator class="hide-on-tablet"></app-simulation-params-activator>
      }
    </app-nav-progress>
  }
</ng-container>
